export default { sha: 'a20f4daff8c597ad136b723da233d78e75f2eaad', buildNumber: 'undefined' }
